import React from 'react';
import { useTranslation } from 'react-i18next';

const Input = ({
    botName,
    textAreaRef,
    handleMessageSend,
    setIsTyping,
    isTyping,
    disabled,
    primary,
    handleShowMenu,
    handlePromptsMenu,
    messageStreaming,
    setMessageStreaming,
    showDisclaimer,
    isIntialLanguageSelected,
}) => {

    const { t, i18n } = useTranslation();

    const textarea = textAreaRef.current;

    const handleSendClick = () => {
        if (textarea.value !== '') {
            handleMessageSend(textarea.value);
            setIsTyping(true);
            setMessageStreaming(true);
            textarea.value = '';
            textarea.style.height = 'auto'
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey && !disabled) {
            if (textAreaRef.current.value.trim() !== '') {
                if (!isTyping && !messageStreaming) {
                    e.preventDefault();
                    handleMessageSend(textarea.value);
                    textarea.value = '';
                    textarea.style.height = 'auto'
                }
            } else {
                e.preventDefault();
            }
        }
    }

    const handleTextareaChange = () => {
        if (textarea) {
            if (textarea.value.trim() === '') {
                // Clear the inline styles when the textarea is empty
                textarea.style.height = '';
                textarea.style.overflowY = '';
            } else {
                textarea.style.height = 'auto';
                textarea.style.height = Math.min(100, textarea.scrollHeight) + 'px';

                if (textarea.scrollHeight > 100) {
                    textarea.style.overflowY = 'auto';
                } else {
                    textarea.style.overflowY = 'hidden';
                }
            }
        }
    };

    return (
        <>
            <div className="border-t-2 border-gray-200 p-2 sm:p-6 sm:mb-0 shadow-lg bg-white z-5">
                <div className="relative flex justify-around items-center">
                    <button className='dropup-icon-link p-0 pr-[5px] cursor-pointer border-0 flex items-center justify-center bg-transparent disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none' onClick={handleShowMenu} disabled={!isIntialLanguageSelected}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="10" r="9.5" stroke={primary} />
                            <path d="M9.68847 7.1417L5.11884 12.2333C5.04256 12.3183 5 12.4311 5 12.5485C5 12.6659 5.04256 12.7788 5.11884 12.8637L5.124 12.8692C5.16099 12.9105 5.2055 12.9434 5.25484 12.9659C5.30418 12.9884 5.35731 13 5.411 13C5.4647 13 5.51783 12.9884 5.56717 12.9659C5.61651 12.9434 5.66102 12.9105 5.69801 12.8692L10.0009 8.07451L14.302 12.8692C14.339 12.9105 14.3835 12.9434 14.4328 12.9659C14.4822 12.9884 14.5353 13 14.589 13C14.6427 13 14.6958 12.9884 14.7452 12.9659C14.7945 12.9434 14.839 12.9105 14.876 12.8692L14.8812 12.8637C14.9574 12.7788 15 12.6659 15 12.5485C15 12.4311 14.9574 12.3183 14.8812 12.2333L10.3115 7.1417C10.2713 7.09692 10.223 7.06128 10.1695 7.03692C10.1159 7.01256 10.0583 7 10 7C9.94174 7 9.88409 7.01256 9.83054 7.03692C9.77699 7.06128 9.72866 7.09692 9.68847 7.1417Z" fill={primary} stroke={primary} strokeWidth="0.5" />
                        </svg>
                    </button>
                    <div className='relative w-[90%] md:w-[96%] flex'>
                        <textarea
                            placeholder={t('Write your message!')}
                            className={`w-full border border-[#e9e9e9] focus:placeholder-gray-400 placeholder-gray-600 text-black outline-none bg-[#fcfcfc] rounded-md pl-2 py-[10px] sm:p-4 resize-none text-[13px] leading-[17px] sm:text-sm message-input ${i18n.language == 'ar' ? 'sm:pr-9 pr-[35px]' : 'sm:pr-16 pr-[40px]'} ${i18n.language == 'ar' && 'text-right'} disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none`}
                            ref={textAreaRef}
                            onKeyDown={handleKeyDown}
                            rows={'1'}
                            onChange={handleTextareaChange}
                            disabled={!isIntialLanguageSelected}
                        />
                        <button className='absolute bg-transparent border-0 right-2 md:right-4 p-0 cursor-pointer send-message flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none' onClick={handleSendClick} disabled={isTyping || disabled || messageStreaming || !isIntialLanguageSelected}>
                            <svg width="15" height="15" viewBox="0 0 19 18" xmlns="http://www.w3.org/2000/svg" fill={primary}>
                                <path d="M18.588 8.33263L2.08802 0.0826268C1.9587 0.0179519 1.81344 -0.00796197 1.66973 0.00800564C1.52602 0.0239732 1.38999 0.0811415 1.27802 0.172627C1.17109 0.262246 1.09128 0.379917 1.04756 0.51241C1.00383 0.644903 0.997935 0.786965 1.03052 0.922627L3.25052 9.00013L1.00052 17.0551C0.969944 17.1684 0.966374 17.2873 0.990102 17.4022C1.01383 17.5171 1.06419 17.6249 1.13714 17.7168C1.21009 17.8087 1.30359 17.8822 1.41012 17.9315C1.51666 17.9807 1.63325 18.0042 1.75052 18.0001C1.86793 17.9994 1.98353 17.9712 2.08802 17.9176L18.588 9.66763C18.7109 9.60469 18.814 9.50907 18.886 9.39129C18.958 9.27352 18.9961 9.13816 18.9961 9.00013C18.9961 8.86209 18.958 8.72674 18.886 8.60896C18.814 8.49119 18.7109 8.39557 18.588 8.33263ZM2.91302 15.8326L4.57052 9.75013H11.5005V8.25013H4.57052L2.91302 2.16763L16.5705 9.00013L2.91302 15.8326Z" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            {showDisclaimer && <div className='warning-message bg-[#fafafa]'>
                <p className='text-[11px] text-center w-[75%] mx-auto my-[7px] leading-[16px]'>{botName + " " + t('can make mistakes. Try clearing your chat if you find unexpected responses.')}</p>
            </div>}
        </>
    )
}

export default Input;